"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getInputBorderRadius = function getInputBorderRadius(theme, isSuffix, isPrefix) {
  if (isSuffix) {
    return "".concat(theme.borderRadius, " 0 0 ").concat(theme.borderRadius);
  }

  if (isPrefix) {
    return "0 ".concat(theme.borderRadius, " ").concat(theme.borderRadius, " 0");
  }

  return theme.borderRadius;
};

var _default = getInputBorderRadius;
exports.default = _default;